import React from 'react';
import * as XLSX from 'xlsx';
import {ExcelData, SimulationData} from "../simulationTypes";
import {
  changeDateStyle, changeToSimulationsStyle,
  clearAllPitch,
  createBlankData,
  createDataAllayToExcel,
  createDateList, loadLocalStorage,
  randomStr, saveLocalStorage
} from "../simulationFunctions";
import {RuleType} from "../RuleType";

type Props = {
  dateStr: string;
  setDateStr: React.Dispatch<React.SetStateAction<string>>;
  dateList: string[];
  setDateList: React.Dispatch<React.SetStateAction<string[]>>;
  simulations: SimulationData[];
  setSimulations: React.Dispatch<React.SetStateAction<SimulationData[]>>;
  rule: RuleType;
}

const readExcelFile = async (file: File): Promise<unknown> => {
  try {
    const buffer = await file.arrayBuffer()
    const workbook = XLSX.read(buffer, {type: 'buffer', bookVBA: true});
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    return XLSX.utils.sheet_to_json(worksheet);
    // console.log(data);
  } catch (e) {
    console.error(e)
  }
}

const createExcelFile = (dataList: ExcelData[]): void => {
  const stub = [...dataList];
  const workbook = XLSX.utils.book_new();
  const sheet1 =XLSX.utils.json_to_sheet(stub);
  XLSX.utils.book_append_sheet(workbook, sheet1, "sheet1");
  XLSX.writeFileXLSX(workbook, "pitch_data.xlsx");
}

export const SimulationHeaderButtons: React.VFC<Props> = (props) => {
  return (
    <div className='p-4'>
      <button
        className='px-4 py-2 mr-3 bg-green-100 rounded-md'
        onClick={()=>{
          // props.simulations.sort();
          props.setSimulations(
            [...props.simulations.sort((a,b)=> a.number.localeCompare(b.number))
              .sort((a,b)=> a.number.length - b.number.length)
              .sort((a,b)=> a.team.localeCompare(b.team))]);
        }}
      >
        整列
      </button>

      <button
        className='px-4 py-2 mr-3 bg-red-200 rounded-md'
        onClick={()=>{
          if(window.confirm('全員の投球数をクリアしますか？')) {
            const newList = clearAllPitch(props.rule, props.simulations);
            props.setSimulations([...newList]);
          }
        }}
      >
        投球数クリア
      </button>

      <button
        className='px-4 py-2 mr-8 bg-red-200 rounded-md'
        onClick={()=>{
          // props.simulations.sort();
          if(window.confirm('全データを消去しますか？')){
            const nowDay = new Date();
            const nowDayStr = nowDay.toLocaleDateString();
            props.setDateStr(changeDateStyle(nowDayStr));
            props.setDateList(createDateList(nowDayStr));
            props.setSimulations([createBlankData(randomStr(12), props.rule)]);
          }
        }}
      >
        オールクリア
      </button>

      <button
        className='px-4 py-2 mr-3 bg-blue-100 rounded-md'
        onClick={()=>{
          saveLocalStorage(props.rule, props.dateStr, props.dateList, props.simulations);
          if(props.rule === RuleType.young) {
            alert('PCにデータを保存しました＠ヤングルール');
          } else if (props.rule === RuleType.junior) {
            alert('PCにデータを保存しました＠ジュニアルール');
          } else if (props.rule === RuleType.littleSenior) {
            alert('PCにデータを保存しました＠リトルシニアルール');
          } else {
            alert('データ保存できません＠設定外リーグ');
          }
        }}
      >
        保存:PC
      </button>

      <button
        className='px-4 py-2 mr-6 bg-blue-100 rounded-md'
        onClick={()=>{
          // localStorageからデータ取得
          const {simulations, date, dateList} = loadLocalStorage(props.rule);
          // データの有無で処理を分岐
          if (simulations && date && dateList) {
            props.setDateStr(date);
            props.setDateList(JSON.parse(dateList));
            props.setSimulations(JSON.parse(simulations));
          } else {
            alert('保存されたデータがありません');
          }
        }}
      >
        読込:PC
      </button>

      <button
        className='px-4 py-2 mr-3 bg-gray-100 rounded-md'
        onClick={()=>{
          const dataList = createDataAllayToExcel(props.dateStr, props.simulations);
          createExcelFile(dataList);
        }}
      >
        保存:Excel
      </button>

      <label htmlFor="filename">
        <span className='px-4 py-2 mr-3 bg-gray-100 rounded-md'>
          読込:Excel
        </span>
        <input type="file" id="filename" className="hidden" accept={'.xls,.xlsx'}
               onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
                 e.preventDefault();
                 const excelData: ExcelData[] = await readExcelFile(e.currentTarget.files![0]) as ExcelData[];
                 const newList = changeToSimulationsStyle(excelData);
                 const newDate = excelData[0].date;
                 props.setDateStr(newDate);
                 props.setDateList(createDateList(newDate));
                 props.setSimulations([...newList]);
                 e.target.value = "";
               }}
        />
      </label>

      <label htmlFor="addFromExcel">
        <span className='px-4 py-2 mr-3 bg-gray-100 rounded-md'>
          表示データ追加:Excel
        </span>
        <input type="file" id="addFromExcel" className="hidden" accept={'.xls,.xlsx'}
               onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
                 e.preventDefault();
                 const excelData: ExcelData[] = await readExcelFile(e.currentTarget.files![0]) as ExcelData[];
                 const newList = changeToSimulationsStyle(excelData);
                 props.setSimulations([...props.simulations.concat(newList)]);
                 e.target.value = "";
               }}
        />
      </label>


    </div>
  );
};
